/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpPolicyBinding } from './gcpPolicyBinding';


export interface GcpPolicyResponse { 
    /**
     * Policy principals and role bindings
     */
    bindings?: Array<GcpPolicyBinding>;
}

